export enum FileProcessingType {
  PageCount = 1,
  Optimization = 2,
  OCR = 3,
  NonPDFtoPDF = 4,
  PDFFix = 5,
  eFax = 6,
  ResolveDocType = 7,
  PublishReadyForEtmf = 8,
  ProcessReviewDoc = 9,
  MSG = 10,
  AutoCoding = 12,
}

export enum FileProcessingStatus {
  NotApplicableForOcr = -1,
  OcrCanBeAdded = 0,
  Pending = 1,
  InProcess = 2, // Publishing
  Complete = 3, // Published
  Error = 4,
  Deleted = 5,
  NotSubmitted = 6,
  UnderQuarantine = 1003,
}
